import { VIDEO_PLATFORM, VIDEO_PLATFORM_REGEX } from 'js/lib/constants'

export type YoutubeTokens = {
    type: typeof VIDEO_PLATFORM.Youtube
    id: string
}

export function extractTokensFromYoutubeUrl(
    value: string,
): YoutubeTokens | null {
    const match = value.match(VIDEO_PLATFORM_REGEX.Youtube)

    if (!match) return null

    return {
        type: VIDEO_PLATFORM.Youtube,
        id: match[7],
    }
}

export default extractTokensFromYoutubeUrl
